import $md5 from "js-md5";
function fourRandom() {
  let arr = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, "a", "b", "c", "d", "e", "f", "g"];
  let salt = "";
  for (let i = 0; i < 4; i++) {
    let num = Math.floor(Math.random() * 17);
    salt = salt + arr[num];
  }
  // console.log(salt);
  return salt;
}
function md5() {
  // this.salt = this.$md5(this.fourRandom());
  let random = fourRandom();
  let salt = random;
  let key = $md5($md5("10658933256849622467" + random) + random);
  // console.log(salt);
  // console.log(key);
  return { salt, key };
}
export default md5();
